import { z } from 'zod';

/** Etat de sante d'une dependance de l'application. */
export const dependencyStatusSchema = z.object({
  name: z.string(),
  status: z.enum(['up', 'down', 'disabled']),
  /** Latence de la verification, en millisecondes. */
  latencyMs: z.number().nonnegative().optional(),
  detail: z.string().optional(),
});

export type DependencyStatus = z.infer<typeof dependencyStatusSchema>;

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  /** Version applicative issue du package.json. */
  version: z.string(),
  /** Version du moteur de simulation. */
  engineVersion: z.number().int().positive(),
  environment: z.enum(['development', 'test', 'production']),
  /** Duree depuis le demarrage du process, en secondes. */
  uptimeSeconds: z.number().nonnegative(),
  /** Horodatage serveur au format ISO 8601. */
  serverTime: z.string(),
  dependencies: z.array(dependencyStatusSchema),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;
